module.exports = __webpack_public_path__ + "img/bDrop.90c4c046.svg";